/**
 * @generated SignedSource<<1c466417e88a04ca65c7008b03de79c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftTokenContractImportStatus = "NFT_TOKEN_CONTRACT_IMPORT_STATUS_COMPLETE" | "NFT_TOKEN_CONTRACT_IMPORT_STATUS_ERROR" | "NFT_TOKEN_CONTRACT_IMPORT_STATUS_PROCESSING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionListTile_contractImport$data = {
  readonly collectionName: string | null;
  readonly completeItems: {
    readonly totalResults: number | null;
  } | null;
  readonly contract: {
    readonly name: string | null;
  } | null;
  readonly importStatus: NftTokenContractImportStatus | null;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly metadata: {
          readonly media?: {
            readonly poster: string | null;
            readonly web: string | null;
          } | null;
        } | null;
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "NftProfileImportCollectionListTile_contractImport";
};
export type NftProfileImportCollectionListTile_contractImport$key = {
  readonly " $data"?: NftProfileImportCollectionListTile_contractImport$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionListTile_contractImport">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionListTile_contractImport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collectionName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "importStatus",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 4
        },
        {
          "kind": "Literal",
          "name": "importStatuses",
          "value": [
            "NFT_ITEM_IMPORT_STATUS_COMPLETE",
            "NFT_ITEM_IMPORT_STATUS_PROCESSING",
            "NFT_ITEM_IMPORT_STATUS_ERROR"
          ]
        }
      ],
      "concreteType": "NftTokenContractImportCreatedItemsConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NftTokenContractImportCreatedItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NftDigitalArtMetadataMedia",
                          "kind": "LinkedField",
                          "name": "media",
                          "plural": false,
                          "selections": [
                            {
                              "alias": "poster",
                              "args": null,
                              "kind": "ScalarField",
                              "name": "posterFrameUrl",
                              "storageKey": null
                            },
                            {
                              "alias": "web",
                              "args": null,
                              "kind": "ScalarField",
                              "name": "webUrl",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "NftDigitalArtMetadata",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "items(first:4,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\",\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
    },
    {
      "alias": "completeItems",
      "args": [
        {
          "kind": "Literal",
          "name": "importStatuses",
          "value": [
            "NFT_ITEM_IMPORT_STATUS_COMPLETE"
          ]
        }
      ],
      "concreteType": "NftTokenContractImportCreatedItemsConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
    }
  ],
  "type": "NftTokenContractImport",
  "abstractKey": null
};
})();

(node as any).hash = "350eb9995c8a4e8f5550fe89577248fd";

export default node;
